import React, { useEffect, useState, useRef, useContext } from 'react'
import { Box } from '@chakra-ui/react'
import { Fireworks as ReactFireworks } from '@fireworks-js/react'
import type { FireworksHandlers } from '@fireworks-js/react'
import { connection, RoomCode } from '../../renderer/roomConnector'
import { RoomSettingsContext } from '../+RoomSettingsContext'
import { ScreenSizeErrorModal } from '../../components/Modals'
import { activities, universalRoomOptions } from '../../activities'
import SideNav from '../../components/SideNav'
let isConnecting = false

const initialRoomSettings = {
  activity: activities.fireworks,
  info: <>{activities.fireworks.description}</>,
  options: {
    ...universalRoomOptions
  }
}
const Page: React.FC = () => {
  const ref = useRef<FireworksHandlers>(null)
  const { setRoomSettings } = useContext(RoomSettingsContext)

  const [roomCode, setRoomCode] = useState('')

  const triggerAction = (message: any): void => {
    if (ref?.current != null) {
      ref.current.launch(1)
    }
  }

  const triggerEnter = (message: any): void => {
    if (ref?.current?.isRunning ?? false) {
      ref?.current?.stop()
    }
  }

  const fireworksCallback = (results: any): void => {
    if (results !== false) {
      setRoomCode(results.roomCode)
    }
  }

  useEffect(() => {
    setRoomSettings(initialRoomSettings)
    if (!isConnecting) {
      isConnecting = true
      connection('fireworks', fireworksCallback, {
        triggerAction,
        triggerEnter
      })
    }
  }, [])

  return (
    <Box sx={styles.container}>
      <ReactFireworks
        ref={ref}
        options={{
          opacity: 0.5,
          delay: {
            min: 100,
            max: 500
          },
          sound: {
            enabled: true,
            files: ['https://fireworks.js.org/sounds/explosion0.mp3']
          }
        }}
        style={{
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          position: 'absolute',
          background: '#000'
        }}
      />
      <RoomCode roomCode={roomCode} />
      <ScreenSizeErrorModal />
      <SideNav />
    </Box>
  )
}

const styles = {
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center'
  }
}

export { Page }
